<template>
  <a-modal :title="title" v-model="modalShow" width="80%" :class="{ 'footer-none': btns.length == 0 }" @cancel="close"
    destroyOnClose>
    <a-form-model class="common-form-inline" :rules="ruleForm" ref="ruleForm" :model="pageData" :label-col="{ span: 7 }"
      :wrapper-col="{ span: 13 }">
      <!-- <a-row>
        <a-col :span="12">
          <a-form-model-item label="使用框架合同">
            <a-radio-group v-model="pageData.invoiceMainContractFlag" :disabled="readonly">
              <a-radio :value="false">否</a-radio>
              <a-radio :value="true">是</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row> -->
      <div class="common-title">合同信息</div>
      <a-row :gutter="24" v-if="pageData.invoiceMainContractFlag">
        <a-col :span="12">
          <a-form-model-item label="是否为框架合同" prop="isMainContract">
            <!-- <a-input
              v-model="invoiceMainContractName"
              placeholder="请输入"
              :disabled="true"
            /> -->
            <a-select v-model:value="pageData.isMainContract" :options="options"  placeholder="请选择" style="width: 200px"
              @change="handleIsMainchange"></a-select>
            <a-popover placement="right">
              <template #content>
                <p>框架合同可以根据实际发生业务调整合同金额</p>
              </template>
              <a-icon type="question-circle" class="common-question" />
            </a-popover>
            <!-- <a-select
              v-else
              show-search
              v-model="pageData.invoiceMainContractId"
              placeholder="请输入关键字"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="getContractList"
              @change="invoiceChange"
            >
              <a-select-option
                v-for="item in invoiceList"
                :key="item.id"
                :value="item.id"
              >{{ item.contractNo }}</a-select-option>
            </a-select> -->
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="框架合同附件">
            <fileUpload :showList="invoiceFile" :disabled="true" name="file" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="是否为框架合同" prop="isMainContract">
            <a-select v-model:value="pageData.isMainContract" :options="options" :disabled='readonly' placeholder="请选择" style="width: 250px"
              @change="handleIsMainchange"></a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="合同编号" prop="contractNo">
            <a-input v-model="pageData.contractNo" placeholder="请输入" :disabled="readonly || !pageData.isMainContract" @blur="getInfo" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="合同名称" prop="contractName">
            <a-input v-model="pageData.contractName" placeholder="请输入" :disabled="readonly || contractDisabled || !pageData.isMainContract" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="合同金额" prop="contractAmt">
            <a-input v-model.number="pageData.contractAmt" placeholder="请输入"
              :disabled="readonly||contractAmountDisabled || !pageData.isMainContract" type="number" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="签订日期" prop="signDate">
            <a-date-picker v-model="pageData.signDate" :showToday="false" placeholder="请输入"
              :disabled="readonly || contractDisabled || !pageData.isMainContract" valueFormat="YYYY-MM-DD" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="12">
                    <a-form-model-item label="交付/履行凭证" prop="deliveryVoucher">
                        <a-input v-model="pageData.deliveryVoucher" placeholder="请输入" :disabled="readonly||contractDisabled"/>
                    </a-form-model-item>
        </a-col>-->
        <a-col :span="12">
          <a-form-model-item label="附件上传" prop="fileId">
            <fileUpload accept=".png, .PNG, .jpg, .JPG, .jpeg, .JPEG, .bmp, .pdf, .PDF, .zip, .ZIP, .rar, .RAR"
              ref="fileUpload" :showList="[pageData.file]" :paramObj="uploadParam" @uploadOk="uploadOk"
              @remove="removeOk" :disabled="readonly || fileReadonly || contractDisabled || !pageData.isMainContract" name="file" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="common-title">单据列表</div>
    <div class="table-common common">
      <a-table size="middle" :columns="columns" :row-key="(record) => record.id" :data-source="tableData"
        :pagination="false" bordered :locale="{ emptyText: '暂无数据' }" :row-selection="tableSelect">
        <template slot="billTime" slot-scope="text">
          {{
            text | dateFormat("YYYY-mm-dd")
          }}
        </template>
        <template slot="docTpCd">发票</template>
        <template slot="invoiceAmountWithVat" slot-scope="text">
          {{
            text | splitK
          }}
        </template>
      </a-table>
      <div class="table-total-none">
        已选记录：
        <span class="text-color-blue">{{ selectedRowKeys.length }} 条</span>
        单据金额：
        <span class="text-color-orange">{{ totalPayable(tableData) | splitK }} 元</span>
        可开立余额：
        <span class="text-color-orange">{{ totalCanPayable(tableData) | splitK }} 元</span>
      </div>
    </div>
    <template slot="footer">
      <a-button v-if="btns.indexOf('close') > -1" class="btn-blue-line" @click="close()">取消</a-button>
      <button-load v-if="btns.indexOf('save') > -1" @clickHandle="save" type="primary" lable="保存" />
      <button-load v-if="btns.indexOf('check') > -1" @clickHandle="check" type="primary" lable="查验" />
    </template>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { getContractInfo, saveContractInfo } from '@/api/payable.js'
import { fileSaveAPI } from '@/api/file.js'
import { mapActions } from 'vuex'
import { contractList } from '@/api/contract.js'
export default {
  props: {
    title: {
      type: String,
      default: function () {
        return '合同详情'
      },
    },
    info: {
      type: [Object],
      default: function () {
        return {}
      },
    },
    selectedRows: {
      type: [Array],
      default: function () {
        return []
      },
    },
    btns: {
      type: Array,
      default() {
        //close、check、save
        return []
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  components: {},
  name: 'invoice-info-dialog',
  data() {
    return {
      modalShow: false,
      confirmLoading: false,
      tableData: this.utils.deepClone(this.selectedRows),
      uploadParam: {
        app: 'portal-pc',
        module: 'payable',
        user: this.$store.getters['home/getUserHeader'].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: 'payable',
      },
      tenantObj: {},
      tenantOption: [],
      pageData: {
        file: null,
        fileId: undefined,
        isMainContract: undefined,
        contractNo: undefined,
        contractAmt: undefined,
        signDate: undefined,
        contractName: undefined,
        invoiceMainContractFlag: false,
        invoiceMainContractId: undefined,
        invoiceMainContractName: undefined,
      },
      options: [
        {
          value: '1',
          label: '是',
        },
        {
          value: '0',
          label: '否',
        }
      ],
      invoiceList: [],
      invoiceFile: [],
      ruleForm: {
        isMainContract: [
          { required: true, message: '请选择是否为框架合同', trigger: 'blur' },
        ],
        invoiceMainContractId: [
          { required: true, message: '框架合同不能为空', trigger: 'blur' },
        ],
        contractNo: [
          { required: true, message: '合同编号不能为空', trigger: 'blur' },
        ],
        contractAmt: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, cbfn) => {
              let minVal = this.totalPayable()
              if (!value) {
                cbfn('合同金额不能为空')
              } else if (value < minVal) {
                cbfn('合同金额不可小于单据总金额：' + minVal + '元')
              } else {
                cbfn()
              }
            },
          },
        ],
        signDate: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, cbfn) => {
              let minVal = this.utils.dateFormat(
                this.getLastDate(),
                'yyyy-MM-dd'
              )
              if (!value) {
                cbfn('签署日期不能为空')
              } else if (
                new Date(value).getTime() > new Date(minVal).getTime()
              ) {
                cbfn('签署日期不可晚于最早开票日期：' + minVal)
              } else {
                cbfn()
              }
            },
          },
        ],
        fileId: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, cbfn) => {
              if (!this.pageData.fileId) {
                cbfn('请上附件')
              } else {
                cbfn()
              }
            },
          },
        ],
      },
      columns: [
        {
          title: '卖方名称',
          dataIndex: 'sellrName',
        },
        {
          title: '卖方社会信用代码',
          dataIndex: 'sellrOrgCode',
        },
        {
          title: '单据类型',
          dataIndex: 'docTpCd',
          width: '90px',
          scopedSlots: { customRender: 'docTpCd' },
        },
        {
          title: '单据编号',
          dataIndex: 'invoiceNumber',
        },
        {
          title: '起始日期',
          dataIndex: 'billTime',
          scopedSlots: { customRender: 'billTime' },
        },
        {
          title: '单据金额',
          dataIndex: 'invoiceAmountWithVat',
          scopedSlots: { customRender: 'invoiceAmountWithVat' },
        },
        {
          title: '可开立余额',
          dataIndex: 'canEstbGldBal',
          scopedSlots: { customRender: 'canEstbGldBal' },
        },
      ],
      selectedRowKeys: [],
      fileReadonly: false,
      contractDisabled: false, //合同要素是否可编辑
      contractAmountDisabled: false, //合同要素是否可编辑
    }
  },
  computed: {
    ...mapGetters({
      userObj: 'home/getUserObj',
    }),
    tableSelect() {
      return {
        type: 'checkbox',
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onTableChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: this.readonly || record.disabled, // Column configuration not to be checked
          },
        }),
      }
    },
  },
  created() {
    this.getDicAsync('InvoiceType').then((res) => {
      this.invoiceTypes = res
    })
  },
  methods: {
    handleIsMainchange() {
      if (this.pageData.isMainContract) {
        this.contractAmountDisabled = false
        this.readonly = false
        this.contractDisabled = false
      }
      this.pageData = {
        file: null,
        fileId: undefined,
        isMainContract: this.pageData.isMainContract,
        contractNo: undefined,
        contractAmt: undefined,
        signDate: undefined,
        contractName: undefined,
        invoiceMainContractFlag: false,
        invoiceMainContractId: undefined,
        invoiceMainContractName: undefined,
      }
    },
    getContractList(value) {
      let params = {
        pageNum: 1,
        pageSize: 100,
        orderBy: 'createTime asc',
        contractNo: value || '',
        buryOrgCode: this.$store.getters['home/getUserObj'].orgCode,
        sellrOrgCode: this.tableData[0].sellrOrgCode,
      }
      contractList(params).then((res) => {
        this.invoiceList = res.data.grid.list
      })
    },
    invoiceChange() {
      this.invoiceFile = []
      let item = this.invoiceList.find((item) => item.id == this.pageData.invoiceMainContractId)
      this.invoiceFile = [item.fileMap]
    },
    ...mapActions({
      getDicAsync: 'app/getDicAsync',
    }),
    open() {
      this.$set(this.pageData, 'invoiceMainContractFlag', false)
      this.invoiceFile = []
      this.modalShow = true
      this.tableData = this.utils.deepClone(this.selectedRows)
      this.selectedRowKeys = this.tableData.map((i) => i.id)
      this.$nextTick(() => {
        if (this.info && this.info.id) {
          this.getInfo()
        }
      })
    },
    getInfo() {
        console.log("%c Line:384 🍩 this.info", "color:#ffdd4d", this.info);
        console.log("%c Line:384 🍩 this.pageData", "color:#ffdd4d", this.pageData);

      if (!this.info.contractNo && !this.pageData.contractNo) {
        return
      }
      getContractInfo({
        contractNo: this.info.contractNo || this.pageData.contractNo,
        isMainContract: (this.info.invoiceContract&&this.info.invoiceContract.isMainContract) || this.pageData.isMainContract || this.info.isMainContract,
        sellrOrgCode:
          this.info.sellrOrgCode ||
          (this.tableData[0] && this.tableData[0].sellrOrgCode),
        buryOrgCode: this.info.buyrOrgCode || this.$store.getters['home/getUserObj'].orgCode,
        useCase: 'receivable',
      }).then((res) => {
        console.log("%c Line:395 🧀 res", "color:#3f7cff", res);
        
        //框架合同
        if (res.data.invoiceMainContract) {
          this.pageData.invoiceMainContractFlag = true
          this.pageData.invoiceMainContractId = res.data.invoiceMainContract.id
          this.pageData.invoiceMainContractName = res.data.invoiceMainContract.contractNo
          this.invoiceFile = [res.data.invoiceMainContractFile]
        } else {
          this.pageData.invoiceMainContractFlag = false
          this.pageData.invoiceMainContractId = undefined
          this.pageData.invoiceMainContractName = undefined
          this.invoiceFile = []
        }

        let info = (res.data && res.data.contract) || {}
        // 合同信息
        if (!this.pageData.contractNo) {
          this.pageData.contractNo = info.contractNo
        }
        this.pageData.id = info.id
        let keys = ['contractAmt', 'signDate', 'contractName', 'fileId']
        keys.forEach((i) => {
          this.$set(this.pageData, i, info[i])
        })

        // 单据列表
        this.tableData = this.utils.deepClone(this.selectedRows)
        this.selectedRowKeys = this.selectedRows.map((i) => i.id)
        let list = (res.data && res.data.invoices) || []
        if(res.data.invoices&&res.data.invoices.length > 0&&res.data.invoices[0].invoiceContract&&res.data.invoices[0].invoiceContract.isMainContract){
          this.pageData.isMainContract = res.data.invoices[0].invoiceContract.isMainContract
          console.log("%c Line:426 🍅 this.pageData.isMainContract", "color:#465975", this.pageData.isMainContract);

        }
        if (this.pageData.id) {
          this.contractDisabled = true
        } else {
          this.contractDisabled = false
        }
        list.forEach((i, index) => {
          list[index].disabled = true
          this.selectedRowKeys.push(i.id)
        })
        this.tableData = this.tableData.concat(list)
        // 文件信息
        this.pageData.file = res.data.file && res.data.file
        this.pageData.fileId = res.data.file && res.data.file.fileId
        if (!this.readonly && res.data && res.data.file) {
          this.fileReadonly = true
          this.$refs.fileUpload.setFileList({
            name: res.data.file.fileNm,
            size: res.data.file.fileSize,
            uid: res.data.file.fileId,
            fileExpdNm: res.data.file.fileExpdNm,
            fileRte: res.data.file.fileRte,
            tblBlId: res.data.file.tblBlId,
          })
        } else {
          this.fileReadonly = false
          this.$refs.fileUpload.setFileList()
        }
        if(res.data && JSON.stringify(res.data) != '{}'){
          

          // 根据 isMainContract 设置 contractAmountDisabled
        if (this.pageData.isMainContract === '1') {
          this.contractAmountDisabled = false;
        } else {
          this.contractAmountDisabled = true;
        }
        }
        
      })
    },
    close() {
      this.pageData = {}
      this.$refs.ruleForm.resetFields()
      this.modalShow = false
    },
    disabledDate(cuurent) {
      // 小于t+1
      let today = new Date().getTime()
      let curDay = new Date(cuurent).getTime()
      if (today > curDay) {
        return true
      }
    },
    //表格选择回调
    onTableChange(selectedRows, data) {
      this.selectedRowKeys = selectedRows
    },
    // 计算表格勾选合计
    totalPayable() {
      let list = this.tableData.filter(
        (i) => this.selectedRowKeys.indexOf(i.id) > -1
      )
      let total = list.reduce((acc, rec) => {
        return acc + (+rec.invoiceAmountWithVat || 0)
      }, 0)
      return total.toFixed(2)
    },
    // 计算表格勾选合计
    totalCanPayable() {
      let list = this.tableData.filter(
        (i) => this.selectedRowKeys.indexOf(i.id) > -1
      )
      let total = list.reduce((acc, rec) => {
        return acc + (+rec.canEstbGldBal || 0)
      }, 0)
      return total.toFixed(2)
    },
    getLastDate() {
      if (this.selectedRowKeys.length === 0) {
        return null
      }
      let dateList = this.tableData.map((i) => {
        if (i.billTime) {
          return new Date(i.billTime.split(' ')[0]).getTime()
        }
      })
      return new Date(Math.min(...dateList))
    },
    // 删除文件
    removeOk() {
      this.pageData.file = null
      this.pageData.fileId = undefined
    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.uploadParam.tblBlId,
        mdlId: 'payable',
      }
      fileSaveAPI(param)
        .then((res) => {
          this.uploading = false
          this.pageData.fileId = res.data.fileId
          this.pageData.file = data
          this.$refs.ruleForm && this.$refs.ruleForm.validateField('fileId')
        })
        .catch((err) => {
          this.uploading = false
          console.log(err)
        })
    },
    uploadOk(resList) {
      this.fileSave(resList[0])
    },
    save(btn) {
      if (this.selectedRowKeys.length == 0) {
        this.$message.warn('请选择单据列表')
        btn && btn.closeLoad()
        return
      }
      let selectList = this.tableData.filter(
        (i) => this.selectedRowKeys.indexOf(i.id) > -1
      )
      let item = selectList[0] || {}
      let diffItem = selectList.find((i) => i.sellrName != item.sellrName)
      if (diffItem) {
        this.$message.warn('勾选记录的卖方名称需一致')
        btn && btn.closeLoad()
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            ...this.pageData,
            ids: this.selectedRowKeys,
            cyCodes: selectList.map((i) => i.cyCode),
            sellrOrgCode: selectList[0].sellrOrgCode,
            useCase: 'receivable',
          }
          params.file = undefined
          saveContractInfo(params)
            .then((res) => {
              this.$message.success('操作成功')
              btn && btn.closeLoad()
              this.close()
              this.$emit('save')
            })
            .catch((err) => {
              btn && btn.closeLoad()
            })
        } else {
          btn && btn.closeLoad()
        }
      })
    },
  },
  watch: {},
  activated() { },
}
</script>
<style scoped lang="less">
.img-tip {
  white-space: nowrap;
}

.common-question {
  color: #ccc;
  font-size: 16px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/contract-info-dialog.vue